import { type JSX } from 'react';

import { useTranslation } from '@cx-modules/i18n-provider';

import { useBookmakerTypeCount } from '../../hooks/useBookmakerTypeCount';
import { getMarketLabel } from '../../utils/labels';

import { Header, MarketHeaderWrapper } from './style';

export interface MarketHeaderProps {
  //marketId: number;
  marketName: string;
}

export const MarketHeader = ({
  //marketId,
  marketName,
}: MarketHeaderProps): JSX.Element => {
  const { exchangeCount, sportsbookCount } = useBookmakerTypeCount();
  const { t } = useTranslation('label');
  const marketNameLabel = getMarketLabel({ marketName, t });

  return (
    <MarketHeaderWrapper numberOfCells={exchangeCount + sportsbookCount}>
      <Header data-testid="grid-header">{marketNameLabel}</Header>
      {/* <OddsInfo marketId={marketId} /> */}
    </MarketHeaderWrapper>
  );
};
